import { IconPresentationProps } from "@insite/mobius/Icon/Icon";
import React from "react";

const Linkedin: React.FC<IconPresentationProps> = props => {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="30" height="30" fill="none" viewBox="0 0 30 30">
            {props.title && <title>{props.title}</title>}
            <path
                fill="#fff"
                d="M15.217 29.38a14.592 14.592 0 01-10.388-4.305A14.59 14.59 0 01.526 14.69 14.6 14.6 0 014.83 4.302 14.596 14.596 0 0115.217 0a14.592 14.592 0 0110.388 4.302 14.597 14.597 0 014.302 10.388 14.589 14.589 0 01-4.303 10.387 14.59 14.59 0 01-10.387 4.303zm3.85-15.362c2.124 0 2.124 2.015 2.124 3.486v6.405h4.085v-7.228c0-2.099-.277-3.471-.899-4.458-.764-1.213-2.072-1.802-3.998-1.802a4.708 4.708 0 00-2.475.672 3.9 3.9 0 00-1.394 1.451h-.055V10.75h-3.921v13.16h4.085v-6.517c0-1.668.29-3.374 2.45-3.374h-.001zM5.89 10.748V23.91h4.088V10.75H5.889zM7.93 4.197a2.37 2.37 0 00-2.366 2.37A2.378 2.378 0 007.93 8.954a2.38 2.38 0 001.672-4.062 2.371 2.371 0 00-1.674-.695l.002-.001z"
            ></path>
        </svg>
    );
};

export default React.memo(Linkedin);
